import { render, staticRenderFns } from "./ConfigMwxMch.vue?vue&type=template&id=4cc21386"
import script from "./ConfigMwxMch.vue?vue&type=script&lang=js"
export * from "./ConfigMwxMch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports